var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 200,
    viewBox: "0 0 250 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4127",
    "data-name": "Group 4127",
    transform: "translate(13560 21653)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20122",
    "data-name": "Rectangle 20122",
    width: 250,
    height: 200,
    transform: "translate(-13560 -21653)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4536",
    "data-name": "Path 4536",
    d: "M23.389,62.435V174.819H163.726V62.435ZM152.032,24.974h23.389c7.017,0,11.695,4.995,11.695,12.487V187.306c0,7.492-4.678,12.487-11.695,12.487H11.695C4.678,199.793,0,194.8,0,187.306V37.461c0-7.492,4.678-12.487,11.695-12.487H35.084V12.487C35.084,4.995,39.762,0,46.779,0S58.474,4.995,58.474,12.487V24.974h70.168V12.487C128.642,4.995,133.32,0,140.337,0s11.695,4.995,11.695,12.487ZM140.337,149.845H116.947V124.871h23.389Zm-35.084,0H81.863V124.871h23.39Zm35.084-37.461H116.947V87.409h23.389Zm-35.084,0H81.863V87.409h23.39ZM70.168,149.845H46.779V124.871H70.168Z",
    transform: "translate(-13529 -21653)",
    fill: "#d2d5da",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherDefault);
export default __webpack_public_path__ + "static/media/other-default.9a4f602b0f4e7f132406a30886150228.svg";
export { ForwardRef as ReactComponent };